/* eslint-disable no-bitwise */ function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, forwardRef } from "react";
import { ChildPropMerger } from "../../utilities/ChildPropMerger";
import { Tunnel } from "../../Tunnel";
import { RemoteComponent } from "../../RemoteComponent";
import useJSONEffect from "../../../utils/lpe-cache/hooks/useJSONEffect";
var JsonRenderer = /*#__PURE__*/ forwardRef(function JsonRenderer(props, ref) {
    var _props_content = props.content, content = _props_content === void 0 ? {} : _props_content, children = props.children, name = props.name, _props_overrideResponseProps = props.overrideResponseProps, overrideResponseProps = _props_overrideResponseProps === void 0 ? {} : _props_overrideResponseProps;
    // Extract top-level feature-interfaces from mbox payload
    var tunnel = content.tunnel, component = content.component, remote = content.remote, _content_mergeChildProps = content.mergeChildProps, mergeChildProps = _content_mergeChildProps === void 0 ? true : _content_mergeChildProps, tmp = content.props, contentProps = tmp === void 0 ? {} : tmp;
    var globalPayloadProps = useJSONEffect(content);
    // Merge all the prop-sources together. Order determines priority.
    // Memoized to prevent re-merging when result would not have changed
    var overrideProps = useMemo(function() {
        return _extends({}, overrideResponseProps, contentProps, globalPayloadProps);
    }, [
        overrideResponseProps,
        contentProps,
        globalPayloadProps
    ]);
    // Apply prop overrides onto the wrapped-component
    var mergedChildren = useMemo(function() {
        return ChildPropMerger({
            children: children,
            overrideProps: overrideProps,
            mergeChildProps: mergeChildProps
        });
    }, [
        children,
        overrideProps,
        mergeChildProps
    ]);
    return useMemo(function() {
        var result = mergedChildren;
        // Wrap in optional Component defined in payload
        if (component) {
            var _mergedChildren;
            result = /*#__PURE__*/ _jsx(RemoteComponent, {
                props: ((_mergedChildren = mergedChildren) == null ? void 0 : _mergedChildren.props) || overrideProps,
                component: component,
                remote: remote,
                ref: ref,
                children: result
            });
        }
        // Wrap in optional tunnel if defined in payload
        if (tunnel) {
            result = /*#__PURE__*/ _jsx(Tunnel, _extends({}, tunnel, {
                name: name,
                ref: ref,
                children: result
            }));
        }
        return result;
    }, [
        component,
        remote,
        mergedChildren,
        name,
        ref,
        tunnel,
        overrideProps
    ]);
});
export { JsonRenderer, useJSONEffect };

//# sourceMappingURL=JsonRenderer.js.map